import { render, staticRenderFns } from "./DashboardRecentIssuedDoc.vue?vue&type=template&id=9b1e8990&"
import script from "./DashboardRecentIssuedDoc.vue?vue&type=script&lang=js&"
export * from "./DashboardRecentIssuedDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports